<template>
  <div id="app">
    <!-- <HelloWorld/> -->
	<router-view></router-view>
  </div>
</template>

<script>
import HelloWorld from './pages/home/home.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style>
	body{
		margin:0;
		padding:0;
	}
</style>